import { useLang } from '@/hooks/lang';
const { $t } = useLang( '@shining3d/info-component.infoComponent' );
import { $logout } from '@/assets/common/common';
export default [
	{
		path: '/info',
		name: 'info',
		component: () => import( '@shining3d/info-component/index.vue' ),
		meta: {
			sideList: [
				{ path: '/info/personalInfo', name: $t( 'personalInformation.side.info' ), icon: 'icon-gerenzhongxin' },
				{ path: '/info/accountPassword', name: $t( 'personalInformation.side.password' ), icon: 'icon-zhanghaomima' },
				{ path: '/info/mfa', name: $t( 'personalInformation.side.mfa' ), icon: 'icon-dunpai' },
			]
		},
		children: [
			{
				path: '/info/personalInfo',
				name: 'personalInfo',
				component: () => import( '@shining3d/info-component/infoList/personal-info.vue' )
			},
			{
				path: '/info/accountPassword',
				name: 'accountPassword',
				component: () => import( '@shining3d/info-component/infoList/account-password.vue' ),
				meta: { logouts: $logout }
			},
			{
				path: '/info/mfa',
				name: 'mfa',
				component: () => import( '@shining3d/info-component/infoList/mfa.vue' )
			},
		],
		redirect: '/info/personalInfo'
	}
];
